import * as t from '../types';
import {
    UPDATE_TUTOR_ONE_2_ONE_FAILED,
    UPDATE_TUTOR_ONE_2_ONE_REQUEST,
    UPDATE_TUTOR_ONE_2_ONE_SUCCESS,
} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function tutorSessionOne2OneUpdateReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.UPDATE_TUTOR_ONE_2_ONE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.UPDATE_TUTOR_ONE_2_ONE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.UPDATE_TUTOR_ONE_2_ONE_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
